var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3587",
  "data-name": "Group 3587",
  transform: "translate(-3 -3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_142",
  "data-name": "Path 142",
  d: "M14.7,3.95V10.6l1.615-1.235a.867.867,0,0,1,1.14,0L19.069,10.6V3H14.7v.95Z",
  transform: "translate(-5.809)",
  fill: "#22a78b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_143",
  "data-name": "Path 143",
  d: "M15.594,3H14.406v8a.842.842,0,0,1-.4.72.708.708,0,0,1-.4.08,1.118,1.118,0,0,1-.475-.16L11,10.04l-2.139,1.6a.723.723,0,0,1-.792.08A.769.769,0,0,1,7.594,11V3H6.406A3.4,3.4,0,0,0,3,6.44v9.12A3.4,3.4,0,0,0,6.406,19h9.188A3.4,3.4,0,0,0,19,15.56V6.44A3.4,3.4,0,0,0,15.594,3Z",
  fill: "#22a78b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_144",
  "data-name": "Path 144",
  d: "M13.649,27.1H8.9a.95.95,0,0,1,0-1.9h4.75a.9.9,0,0,1,.95.95A.952.952,0,0,1,13.649,27.1Z",
  transform: "translate(-2.576 -10.607)",
  fill: "#22a78b"
}))));
export default __webpack_public_path__ + "static/media/allProducts.87b3a136.svg";
export { SvgComponent as ReactComponent };